import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconCircleComponent } from "./med-icon-circle.component";

@NgModule({
  declarations: [
    MedIconCircleComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconCircleComponent,
  ],
})
export class MedIconCircleModule { }
